var EMPTY_LOADER_STRING = `export function loader() {return "__vxrn__loader__"};`;
function makeLoaderRouteIdStub(routeId) {
  return `export function loader() {return ${JSON.stringify(routeId)}};`;
}
var SERVER_CONTEXT_POST_RENDER_STRING = `_one_post_render_data_`;
export {
  EMPTY_LOADER_STRING,
  SERVER_CONTEXT_POST_RENDER_STRING,
  makeLoaderRouteIdStub
};
//# sourceMappingURL=constants.js.map
